// src/pages/AGBPage.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AGBPage = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <Paper elevation={3} sx={{ maxWidth: 800, p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Allgemeine Geschäftsbedingungen (AGB)
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>1. Geltungsbereich</strong>
          <br />
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen [Dein Unternehmen] (nachfolgend „Anbieter“) und dem Kunden abgeschlossen werden. Entgegenstehende oder abweichende Bedingungen des Kunden finden keine Anwendung, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich zu.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>2. Vertragsschluss</strong>
          <br />
          Durch das Absenden einer Bestellung auf unserer Website gibt der Kunde ein verbindliches Angebot auf Abschluss eines Kaufvertrages ab. Der Anbieter nimmt dieses Angebot an, indem er dem Kunden eine Auftragsbestätigung sendet oder die bestellte Ware liefert.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>3. Preise und Zahlung</strong>
          <br />
          Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer und exklusive Versandkosten. Der Kunde hat verschiedene Zahlungsmöglichkeiten, die beim Bestellvorgang angezeigt werden.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>4. Lieferung</strong>
          <br />
          Die Lieferung erfolgt an die vom Kunden angegebene Adresse. Angaben zur Lieferzeit sind unverbindlich, es sei denn, der Liefertermin wurde ausdrücklich zugesagt.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>5. Eigentumsvorbehalt</strong>
          <br />
          Die Ware bleibt bis zur vollständigen Bezahlung Eigentum des Anbieters.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>6. Widerrufsrecht</strong>
          <br />
          Verbraucher haben ein Widerrufsrecht nach Maßgabe der Widerrufsbelehrung.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>7. Gewährleistung</strong>
          <br />
          Die gesetzliche Gewährleistung gilt. Im Fall von Mängeln kann der Kunde Nacherfüllung verlangen. Wenn die Nacherfüllung fehlschlägt, ist der Kunde berechtigt, den Kaufpreis zu mindern oder vom Vertrag zurückzutreten.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>8. Haftung</strong>
          <br />
          Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten, jedoch der Höhe nach begrenzt auf den vertragstypischen, vorhersehbaren Schaden.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>9. Datenschutz</strong>
          <br />
          Der Anbieter erhebt und verarbeitet personenbezogene Daten des Kunden nur im Rahmen der gesetzlichen Bestimmungen und unserer Datenschutzerklärung.
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          <strong>10. Schlussbestimmungen</strong>
          <br />
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt. Es gilt das Recht der Bundesrepublik Deutschland.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AGBPage;
